import { render, staticRenderFns } from "./ats-manager-table.vue?vue&type=template&id=2046ce0e&scoped=true"
import script from "./ats-manager-table.vue?vue&type=script&lang=ts"
export * from "./ats-manager-table.vue?vue&type=script&lang=ts"
import style0 from "./ats-manager-table.vue?vue&type=style&index=0&id=2046ce0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2046ce0e",
  null
  
)

export default component.exports